import { Grid, Typography } from "@material-ui/core";
import { UserType } from "helpers/enums";
import { applicationContext,appUserContext } from "helpers/services";
import { useContext } from "react";
import { ticketContext } from "../../TicketContext";


let ReadOnly = () => {
    let {  customerServiceUsers, userGroups, ticketStatuses, ticketPriorities } = useContext(applicationContext);
    let { currentUser } = useContext(appUserContext);
    let { ticket, assignableUsers } = useContext(ticketContext);

    return (
        <>
            <Grid container>
                <Grid item xs>
                    <Typography variant="subtitle2"><b>Status</b></Typography>
                    <Typography variant="body1">{ticketStatuses.find(x => x.id === ticket.ticketStatusId)?.
                                [(currentUser?.typology == UserType.VitecUser ? "name" : "customerStatus")]}</Typography>
                </Grid>

                <Grid item xs>
                    <Typography variant="subtitle2"><b>Priority</b></Typography>
                    <Typography variant="body1">{ticketPriorities.getValueByKey(ticket.ticketPriorityId, 'id', 'description')}</Typography>
                </Grid>

                <Grid item xs>
                    <Typography variant="subtitle2"><b>Who's Next</b></Typography>
                    <Typography variant="body1">{ticket.whosNext}</Typography>
                </Grid>

            </Grid>
            <Grid container alignItems="center">
                <Grid item xs>
                    <Typography variant="subtitle2"><b>Customer service assignee</b></Typography>
                    <Typography variant="body1">{customerServiceUsers.getValueByKey(ticket.customerServiceAssignee) || 'Not assigned'}</Typography>
                </Grid>
            </Grid>

            {currentUser?.typology === UserType.VitecUser &&
                <>
                    <Grid container>
                        <Grid item xs>
                            <Typography variant="subtitle2"><b>Assignee</b></Typography>
                            <Typography variant="body1">
                                {ticket.assignee ? assignableUsers.getValueByKey(ticket.assignee, 'email', 'name') : 'Not assigned'}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container>
                        <Grid item xs>
                            <Typography variant="subtitle2"><b>Groups</b></Typography>
                            <Typography variant="body1">
                                {userGroups.filter(x => ticket.groups.indexOf(x.key) !== -1).map(x => x.value).join(", ")}
                            </Typography>
                        </Grid>
                    </Grid>
                </>
            }
        </>
    )
}

export default ReadOnly;